import Region from '@/creditflowresearch/domain/Region/Region';
import { RegionType } from '@/creditflowresearch/domain/Region/RegionType';
import { EMEA_REGION_ID, EMEA_ABBREVIATION } from '@/creditflowresearch/domain/Region/constants';
import { EUROPEAN_MARKET_ID } from '@/creditflowresearch/domain/Market/constants';

class EmeaRegion extends Region {
  static readonly REGION_ID: string = EMEA_REGION_ID;

  static readonly ABBREVIATION: string = EMEA_ABBREVIATION;

  static readonly TYPE: RegionType = RegionType.EMEA;

  protected getMarketIdForRegion(): string | null {
    return EUROPEAN_MARKET_ID;
  }
}

export default EmeaRegion;
